import { CreateAvaturnExportRequest } from '~/types';

const avaturnKey = {
  all: ['avaturn'] as const,
  getAvaturnUserId: () => [...avaturnKey.all, 'user_id'] as const,
  createAvaturnExport: (request: CreateAvaturnExportRequest) =>
    [...avaturnKey.all, 'id', request.avatar_id] as const,
} as const;

export default avaturnKey;
